export const appShopcartQuantity = {
    create: function(){
        var that = this;
        if($('.js-shopcart-quantity-box').length){
            that.bindEvents();
        }
    },
    bindEvents: function(){
        var that = this;
        $(document).on('click', '.js-scq-up', function(e){
            var product = $(this).closest('.js-shopcart-quantity-box'),
                numField = $(product).find('.js-scq-number');
            $(numField)[0].stepUp();
            $(numField).trigger('input');
        });
        $(document).on('click', '.js-scq-down', function(e){
            var product = $(this).closest('.js-shopcart-quantity-box'),
                numField = $(product).find('.js-scq-number');
            $(numField)[0].stepDown();
            $(numField).trigger('input');
        });
        $(document).on('input', '.js-scq-number', function(){
            var product = $(this).closest('.js-shopcart-quantity-box'),
                number = parseInt($(this).val()),
                subTotal = $(product).find('.js-q-subtot'),
                decimal = $(product).attr('data-dec'),
                currency = $(product).attr('data-cur'),
                cost = Number($(product).attr('data-cost')),
                newSubtotal = (Math.round((cost * number) * 100) / 100).toFixed(2),
                strSubtotal = '';
            //console.log('quantity: ', number);
            if(newSubtotal % 1 === 0){
                var end = decimal + '-',
                    temp = newSubtotal.toString(),
                    reDec = temp.replace('.00', end);
             } else{
                var temp = newSubtotal.toString(),
                    reDec = temp.replace('.', decimal);
             }
             $(subTotal).html(currency + ' ' + reDec);
        });
    }
};